import * as React from 'react';

export const Download = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="-2 -1 25 24" {...props}>
    <path
      fill="currentColor"
      d="M11.5,17.6746212 L16.7604076,12.4142136 L17.4675144,13.1213203 L10.75,19.8388348 L4.03248558,13.1213203 L4.73959236,12.4142136 L10.5,18.1746212 L10.5,0.75 L11.5,0.75 L11.5,17.6746212 Z M19,20.25 L19,21.25 L3,21.25 L3,20.25 L19,20.25 Z"
    />
  </svg>
);
